import {handleUpdateNeeded} from '@/shared/integrations/zero/on-update-needed'
import {useAuth} from '@/modules/auth/api'
import {mutators} from '@cypro/admin-engine/mutators'
import {AuthContext, schema} from '@cypro/admin-engine/schema'
import {useMemo} from 'react'

export function useZeroProps() {
  const {auth} = useAuth()

  return useMemo(() => {
    const context: AuthContext | undefined = auth?.user
      ? {
          user: {id: auth.user.id, email: auth.user.email},
        }
      : undefined

    return {
      storageKey: 'cypro',
      cacheURL: new URL('/zero', location.origin).toString(),
      userID: auth?.user?.id,
      schema,
      mutators,
      context,
      hiddenTabDisconnectDelay: 86_400_000,
      onUpdateNeeded: handleUpdateNeeded,
    } as const
    // oxlint-disable-next-line exhaustive-deps the specified deps are enough
  }, [auth?.user?.id, auth?.user?.email, auth?.session?.access, auth?.session?.groups])
}
